import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Activity, CheckCircle, Clock } from 'lucide-react';

const PetStatusOverview = ({ stats, delay = 0 }) => {
  const statusItems = [
    {
      label: 'In Our Care',
      value: stats?.pets_in_care || 0,
      icon: Activity,
      color: 'info',
      bgColor: 'bg-[hsl(var(--info-light))]',
      textColor: 'text-[hsl(var(--info))]'
    },
    {
      label: 'Completed',
      value: stats?.pets_completed || 0,
      icon: CheckCircle,
      color: 'success',
      bgColor: 'bg-[hsl(var(--success-light))]',
      textColor: 'text-[hsl(var(--success))]'
    },
    {
      label: 'Pending',
      value: stats?.pets_pending || 0,
      icon: Clock,
      color: 'warning',
      bgColor: 'bg-[hsl(var(--warning-light))]',
      textColor: 'text-[hsl(var(--warning))]'
    },
    ...(stats?.pets_prepayment > 0 ? [{
      label: 'Pre-booked',
      value: stats.pets_prepayment,
      icon: Clock,
      color: 'muted',
      bgColor: 'bg-muted/40',
      textColor: 'text-muted-foreground'
    }] : [])
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      data-testid="pet-status-overview"
    >
      <Card className="border-0 shadow-md">
        <CardHeader>
          <CardTitle className="text-lg" style={{ fontFamily: 'Fredoka, sans-serif' }}>
            Pet Status Overview
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {statusItems.map((item, index) => (
              <motion.div
                key={item.label}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3, delay: delay + (index * 0.1) }}
                whileHover={{ scale: 1.05 }}
                className="relative"
              >
                <div className={`p-4 rounded-xl ${item.bgColor} group hover:shadow-md transition-all duration-300`}>
                  <div className="flex items-center justify-between mb-2">
                    <item.icon className={`h-5 w-5 ${item.textColor}`} />
                    <motion.span
                      className={`text-2xl font-bold ${item.textColor}`}
                      style={{ fontFamily: 'Fredoka, sans-serif' }}
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      transition={{ type: 'spring', stiffness: 200, delay: delay + (index * 0.1) + 0.2 }}
                    >
                      {item.value}
                    </motion.span>
                  </div>
                  <p className="text-sm font-medium text-muted-foreground">{item.label}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default PetStatusOverview;